const IncentivePilot = ({}, context) => {
  const {utils: {user: {id: userId}, company: {companyData: {incentivePilotURL = ''}}}} = context;

  if(!incentivePilotURL) {
    return null;
  }

  try {
    const URLObj = new URL(incentivePilotURL);

    URLObj.searchParams.append('userId', userId);

    return <iframe data-test-id="incentive-pilot-iframe" src={URLObj.toString()} className="incentive-pilot-iframe" />;
  }
  catch(error) {
    return null;
  }
};

IncentivePilot.contextTypes = {
  utils: PropTypes.object.isRequired
};

export default IncentivePilot;
